import notificationService from '@/components/NavBar/notifications/services/notificationService'
import { PaginatorDatasource } from '@/shared/resources/datasources/paginator/paginator-datasource'
import { CommonFilterModel, CommonSortModelResource } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { GridUtils } from '@/shared/util/grid-utils'

export class NotificationsGridDatasource<T> extends PaginatorDatasource<T> {
    private readonly _isAlarm: boolean

    constructor(isAlarm: boolean) {
        super(notificationService)
        this._isAlarm = isAlarm
    }

    paginator(
        filterModel: CommonFilterModel,
        sortModel: CommonSortModelResource[],
        page: number = 0,
        size: number = 20
    ): Promise<IResponseAgGrid<T>> {
        if (!this.service) {
            throw new Error('undefined service')
        }

        const params = {
            isAlarm: this._isAlarm,
            sort: GridUtils.getSortValue(sortModel),
            page,
            size
        }
        return this.service.paginator(filterModel, params)
    }
}
